module.exports = __webpack_public_path__ + "static/media/br.9dfc8326.webp";